<template>
  <a-modal v-model="visible" title="" onOk="handleOk" width="600px">
    <template slot="footer">
      <a-button
        key="submit"
        style="background-color:#20409a; color: #fff"
      >
        Ok
      </a-button>
    </template>
    <h4 class="font-weight-bolder text-left kova-text">
      Scheduled Live Call
    </h4>
    <div class="">
      <p>
        Your live interview exercise is on:
        <span class="font-weight-bolder"
          >{{ date | dateOnly }} {{ time | timeOnly }}</span
        >
      </p>
    </div>
    <div class="row">
      <div class="col-12 col-md-6"></div>
      <div class="col-12 col-md-6">
        <div class="mt-3 mt-md-4">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span
                ><a-icon
                  type="info-circle"
                  style="position:relative; bottom: 3px;font-size: 16px;"
                />
                Click to copy to artboard</span
              >
            </template>
            <span class="kova-id px-3 py-2 text-white font-weight-bolder"
              >Call ID: Kovatek.id.2245</span
            >
          </a-tooltip>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      time: Date.now(),
      date: Date.now(),
      interviewDate: Date.now(),
      loading: false,
      // time: Date.now(),
    };
  },
};
</script>

<style></style>
